import React, { forwardRef, useMemo } from 'react'
import { FieldTypes } from 'utils/formUtils';
import NetSparkerMappingForm from './NetSparkerMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import { urlRegexValidator } from 'utils/formUtils';
import { Alert } from 'antd';

function NetSparkerCredentialsForm(props, ref) {
    const fields = useMemo(() => (
    [{
        name: "apiEndpoint",
        label: "API Endpoint",
        rules: [urlRegexValidator],
        help: "Required only for On-Prem"
    }, {
        name: "userId",
        label: "User ID",
        required: true
    },{
        name: "apiToken",
        label: "Token",
        type: FieldTypes.PASSWORD,
        required: true
    },
    {
        name: "message",
        type: FieldTypes.LABEL,
        value: <Alert type='warning' message="Websites for this integration will be available after few minutes of adding the credentials, since they are pulled in background."/>
    }
]
    ),[])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={NetSparkerMappingForm}
            initialValue={{ apiEndpoint: 'https://www.netsparkercloud.com/api/1.0' }}
        />
    )
}

export default forwardRef(NetSparkerCredentialsForm);